import { ApiHosts, handleResponseOld, makeGet } from '../../api/helpers';
import { StoreFrontData } from '@/redux/modules/storefront/storefront.types';

/**
 * @category Item API
 * @see getLotsBySellerId
 */
type GetLotsBySellerIdParams = {
    authToken: string;
    deployment: string;
    sellerId: number;
};

type GetLotsBySellerIdResponse = {
    data: StoreFrontData;
    error: boolean;
    message: string;
};

/**
 * fetches storefront lots for given sellerId via Get to Item API Service
 * @function getLotsBySellerId
 * @category Item API
 * @param {GetLotsBySellerIdParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/sellers/${sellerId}/items
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/react-site/routes/get-spa-storefront-items.ts
 */
export const getLotsBySellerId = ({ authToken, deployment, sellerId }: GetLotsBySellerIdParams) =>
    new Promise<GetLotsBySellerIdResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `spa/sellers/${sellerId}/items`,
            authToken,
            deployment,
            path: ApiHosts.ItemApi,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
